import React from "react";
import { XCircle, X } from "lucide-react";

interface ErrorAlertProps {
  error: string;
  onDismiss?: () => void;
  className?: string;
  children?: React.ReactNode;
}

export const ErrorAlert: React.FC<ErrorAlertProps> = ({ error, onDismiss, className = "", children }) => {
  if (!error) return null;

  return (
    <div className={`flex flex-col gap-2 px-4 py-3 bg-red-500/10 border border-red-500/20 text-red-400 rounded-xl text-xs font-semibold leading-normal ${className}`}>
      <div className="flex items-start gap-2">
        <XCircle size={16} className="shrink-0 mt-0.5" />
        <span className="flex-1">{error}</span>
        {onDismiss && (
          <button 
            onClick={onDismiss} 
            className="shrink-0 p-1 hover:bg-red-500/20 rounded-md transition-colors text-red-400"
            type="button"
          >
            <X size={14} />
          </button>
        )}
      </div>
      {children && <div className="mt-1 ml-6">{children}</div>}
    </div>
  );
};
